var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Link',{staticClass:"support-footer",attrs:{"to":"partner.care@tamara.co","track-id":"sidebar_support_email"}},[_c('svg-icon',{attrs:{"name":"email","width":"16px","height":"16px"}}),_c('span',{staticClass:"tamara-english-regular-4"},[_vm._v("partner.care@tamara.co")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }